(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["countdown-timer"] && !Shopify.designMode) return;
  try {
    (function() {
    class CountdownPassword {
      constructor(element) {
        this.element = element;
        this.targetDate = new Date(element.dataset.countdownTarget).getTime();
        this.daysEl = element.querySelector('[data-days]');
        this.hoursEl = element.querySelector('[data-hours]');
        this.minutesEl = element.querySelector('[data-minutes]');
        this.secondsEl = element.querySelector('[data-seconds]');
        this.timerEl = element;
        this.endedEl = element.parentElement.querySelector('.countdown-password-ended');
        this.interval = null;

        if (!isNaN(this.targetDate)) {
          this.start();
        }
      }

      pad(num) {
        return String(num).padStart(2, '0');
      }

      update() {
        const now = new Date().getTime();
        const distance = this.targetDate - now;

        if (distance < 0) {
          this.end();
          return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        if (this.daysEl) this.daysEl.textContent = this.pad(days);
        if (this.hoursEl) this.hoursEl.textContent = this.pad(hours);
        if (this.minutesEl) this.minutesEl.textContent = this.pad(minutes);
        if (this.secondsEl) this.secondsEl.textContent = this.pad(seconds);
      }

      start() {
        this.update();
        this.interval = setInterval(() => this.update(), 1000);
      }

      end() {
        if (this.interval) {
          clearInterval(this.interval);
        }
        if (this.timerEl) {
          this.timerEl.style.display = 'none';
        }
        if (this.endedEl) {
          this.endedEl.style.display = 'block';
        }
      }

      destroy() {
        if (this.interval) {
          clearInterval(this.interval);
        }
      }
    }

    function initCountdowns() {
      document.querySelectorAll('.countdown-password-timer').forEach(el => {
        if (!el._countdownInstance) {
          el._countdownInstance = new CountdownPassword(el);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCountdowns);
    } else {
      initCountdowns();
    }

    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      document.addEventListener('shopify:section:load', initCountdowns);
      document.addEventListener('shopify:section:unload', function(event) {
        const timers = event.target.querySelectorAll('.countdown-password-timer');
        timers.forEach(timer => {
          if (timer._countdownInstance) {
            timer._countdownInstance.destroy();
            delete timer._countdownInstance;
          }
        });
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
